import { ContentContainer, SectionHeader } from '@snsw/react-component-library';

import PropTypes from 'prop-types';
import React from 'react';

const PageLayout = (props) => {
  return (
    <>
      <SectionHeader intro={props.intro} label={props.label} title={props.title} />

      <main id="sectionMain">
        <ContentContainer>{props.children}</ContentContainer>
      </main>

      {props.footer}
    </>
  );
};

PageLayout.propTypes = {
  intro: PropTypes.element,
  label: PropTypes.string,
  title: PropTypes.string,
  footer: PropTypes.element,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

PageLayout.defaultProps = {
  intro: null,
  label: null,
  title: null,
  footer: null,
};

export { PageLayout };
